import { TagOutlined } from '@ant-design/icons';
import { Button, theme } from 'antd';
import { useTranslation } from 'react-i18next';

import appI18n from '../../../config/i18n';

const I18N = 'scenes.leads.scene.bulk_bar';

interface BulkTagLeadsBarProps {
  count: number;
  onTag: () => void;
  onClear: () => void;
}

/** Selection bar, same layout as the Requirements bulk bar. */
function BulkTagLeadsBar({ count, onTag, onClear }: BulkTagLeadsBarProps) {
  const { t } = useTranslation(undefined, { i18n: appI18n });
  const { token } = theme.useToken();

  return (
    <div
      className="leads-bulk-bar"
      style={{
        background: token.colorPrimaryBg,
        borderColor: token.colorPrimaryBorder,
        color: token.colorPrimaryText,
      }}
    >
      <span>
        <strong style={{ color: token.colorPrimaryTextActive }}>{count}</strong>{' '}
        {t(`${I18N}.selected`, { count })}
      </span>
      <div className="leads-bulk-actions">
        <Button type="primary" icon={<TagOutlined />} onClick={onTag}>
          {t(`${I18N}.tag_action`)}
        </Button>
        <Button onClick={onClear}>{t(`${I18N}.clear_selection`)}</Button>
      </div>
    </div>
  );
}

export default BulkTagLeadsBar;
